import { Button } from "@shared/ui/button";
import { Home, FileText } from "lucide-react";

interface AddressInformationReviewProps {
  data?: any;
  onEdit?: () => void;
}

export function AddressInformationReview({
  data,
  onEdit,
}: AddressInformationReviewProps) {
  const rawServiceAddress =
    data?.service_address ||
    data?.serviceAddress ||
    data?.service_address_data ||
    data?.serviceAddressData ||
    data?.addressData?.service ||
    data?.address_data?.service ||
    data?.addressData?.service_address ||
    data?.address_data?.service_address ||
    data?.addressData?.primary ||
    data?.address_data?.primary;

  const houseUnit =
    rawServiceAddress?.house_unit_number ||
    rawServiceAddress?.house_unit ||
    rawServiceAddress?.houseNumber ||
    rawServiceAddress?.unit ||
    rawServiceAddress?.house_no ||
    "";
  const streetAddress =
    rawServiceAddress?.street_address ||
    rawServiceAddress?.streetAddress ||
    rawServiceAddress?.address ||
    rawServiceAddress?.street ||
    "";
  const city =
    rawServiceAddress?.city_display ||
    rawServiceAddress?.city ||
    rawServiceAddress?.city_name ||
    "";
  const zipCode =
    rawServiceAddress?.zip_postal_code ||
    rawServiceAddress?.zipPostalCode ||
    rawServiceAddress?.zipcode ||
    rawServiceAddress?.zipCode ||
    rawServiceAddress?.zip ||
    rawServiceAddress?.postal_code ||
    "";

  const hasServiceAddress =
    !!rawServiceAddress &&
    (!!houseUnit || !!streetAddress || !!city || !!zipCode);

  const rawMailingAddress =
    data?.same_as_service_address || data?.sameAsServiceAddress
      ? rawServiceAddress
      : data?.mailing_address ||
        data?.mailingAddress ||
        data?.billing_address_data ||
        data?.billingAddressData ||
        data?.addressData?.billing ||
        data?.address_data?.billing ||
        data?.addressData?.billing_address ||
        data?.address_data?.billing_address ||
        data?.addressData?.mailing ||
        data?.address_data?.mailing;

  const mailingHouseUnit =
    rawMailingAddress?.house_unit_number ||
    rawMailingAddress?.house_unit ||
    rawMailingAddress?.houseNumber ||
    rawMailingAddress?.unit ||
    rawMailingAddress?.house_no ||
    "";
  const mailingStreetAddress =
    rawMailingAddress?.street_address ||
    rawMailingAddress?.streetAddress ||
    rawMailingAddress?.address ||
    rawMailingAddress?.street ||
    "";
  const mailingCity =
    rawMailingAddress?.city_display ||
    rawMailingAddress?.city ||
    rawMailingAddress?.city_name ||
    "";
  const mailingZipCode =
    rawMailingAddress?.zip_postal_code ||
    rawMailingAddress?.zipPostalCode ||
    rawMailingAddress?.zipcode ||
    rawMailingAddress?.zipCode ||
    rawMailingAddress?.zip ||
    rawMailingAddress?.postal_code ||
    "";

  const hasMailingAddress =
    !!rawMailingAddress &&
    (!!mailingHouseUnit ||
      !!mailingStreetAddress ||
      !!mailingCity ||
      !!mailingZipCode);

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-900">
          Address Information
        </h2>
        <Button variant="outline" size="sm" onClick={onEdit}>
          Edit
        </Button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Service Address */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <Home className="h-5 w-5 text-blue-600" />
            <h3 className="text-base font-semibold text-gray-900">
              Service Address
            </h3>
          </div>
          {hasServiceAddress ? (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              {houseUnit && <p className="text-sm text-gray-900">{houseUnit}</p>}
              {streetAddress && (
                <p className="text-sm text-gray-900">{streetAddress}</p>
              )}
              <p className="text-sm text-gray-900">
                {city}
                {city && zipCode ? `, ${zipCode}` : zipCode}
              </p>
            </div>
          ) : (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <p className="text-sm text-gray-600 italic">
                No service address provided
              </p>
            </div>
          )}
        </div>

        {/* Mailing Address */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <FileText className="h-5 w-5 text-green-600" />
            <h3 className="text-base font-semibold text-gray-900">
              Mailing Address
            </h3>
          </div>
          {hasMailingAddress ? (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              {mailingHouseUnit && (
                <p className="text-sm text-gray-900">{mailingHouseUnit}</p>
              )}
              {mailingStreetAddress && (
                <p className="text-sm text-gray-900">{mailingStreetAddress}</p>
              )}
              <p className="text-sm text-gray-900">
                {mailingCity}
                {mailingCity && mailingZipCode
                  ? `, ${mailingZipCode}`
                  : mailingZipCode}
              </p>
            </div>
          ) : (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <p className="text-sm text-gray-600 italic">
                No address provided
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}